import { defineComponent as _defineComponent } from 'vue'
import { useDeleteValueChainMutation } from '~/types/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'DelValueChain',
  props: {
    chain: null
  },
  setup(__props: any) {


const { mutate: deleteValueChain, loading: delLoading } =
  useDeleteValueChainMutation()

return { __sfc: true,deleteValueChain, delLoading }
}

})